import Rails from '@rails/ujs';
import { ref } from 'vue';
import api from './index';

const token = ref(Rails.csrfToken());
let headers = {};
if (token.value) {
  headers = { 'X-CSRF-Token': token.value };
}

const PAGE_SIZE = 10;

export default {
  index(makerId: number, queryParams?: string, pageNumber = 1, pageSize = PAGE_SIZE) {
    let path = `/api/internal/discounts?maker_id=${makerId}&page[number]=${pageNumber}&page[size]=${pageSize}`;
    if (queryParams) path += `&${queryParams}`;

    return api({
      method: 'get',
      url: path,
      headers,
    });
  },

  products(discountId: number, pageNumber = 1, pageSize = 12) {
    const path = `/api/internal/discounts/${discountId}/products?page[number]=${pageNumber}&page[size]=${pageSize}`;

    return api({
      method: 'get',
      url: path,
      headers,
    });
  },
};
